import { memo, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { QR_CODE_WRAPPER } from 'utils/constants.json';

const QRCode = ({ serviceId, userId, serviceName, userName }) => {
	const [container, setContainer] = useState(() => null);

	const openQRPopup = useCallback(() => {
		const popup = window.open(`/qrcode/?service=${serviceId}&uploadUser=${userId}&serviceName=${serviceName}&userName=${userName}`, 'QR Code drucken', 'width=1200,height=900');
		popup.window.print();
	}, [serviceId, userId, serviceName, userName]);

	useEffect(() => setContainer(document.getElementById(QR_CODE_WRAPPER)), []);

	if (!container) return null;

	return createPortal(<i title='QR Code drucken' className='fa fa-qrcode qr-code ml-3 pointer' onClick={openQRPopup} />, container);
};

export default memo(QRCode);
